import { InjectionToken } from '@angular/core';

export type QueryBreakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl';

export interface LayoutBreakpoint {
  sidebarBreakpoint: QueryBreakpoint;
  headerBreakpoint: QueryBreakpoint;
  appbarBreakpoint: QueryBreakpoint;
}

export const LAYOUT_BREAKPOINT = new InjectionToken<LayoutBreakpoint>('LAYOUT_BREAKPOINT', {
  providedIn: 'root',
  factory: () => ({
    sidebarBreakpoint: '4xl',
    headerBreakpoint: 'md',
    appbarBreakpoint: 'md',
  }),
});
